import { PreferenceRule } from '../../../integrated-client/models/';

export type PreferencesList = Array<PreferenceRule>;

export class ResultsData {

  items: PreferencesList

  constructor() {
    this.items = [];
  }

}
